export type DashboardConfig = {
  dashboardId: string;
  sheetId?: string;
  visualId?: string;
};

type DashboardEnvironmentConfig = {
  dev: DashboardConfig;
  prod: DashboardConfig;
};

type Dashboards = {
  [key: string]: DashboardEnvironmentConfig;
};

const dashboards: Dashboards = {
  'Survey Results': {
    dev: {
      dashboardId: '62d2017a-a8f9-424f-8868-772054a5b782',
    },
    prod: {
      dashboardId: '49118504-5191-46bd-890a-3e6fb50aa1b3',
    },
  },
  'My Learning Apps': {
    dev: {
      dashboardId: '9fb4487c-44ea-443b-845b-b985e283777a',
    },
    prod: {
      dashboardId: '45ba1376-ee97-434f-ac11-faf20afebb66',
    },
  },
  'Leaderboard Non-student Units Mastered': {
    dev: {
      dashboardId: '234a776e-1543-41dc-8b27-29e48be1f737',
    },
    prod: {
      dashboardId: '234a776e-1543-41dc-8b27-29e48be1f737',
    },
  },
  'Leaderboard Student - Units Mastered by Subject Visual': {
    dev: {
      dashboardId: '234a776e-1543-41dc-8b27-29e48be1f737',
      sheetId: '234a776e-1543-41dc-8b27-29e48be1f737_026b30a9-aa34-4a96-b463-dfcd17f32d1a',
      visualId: '234a776e-1543-41dc-8b27-29e48be1f737_00868099-683c-49e7-80f1-8aa27bdc2518',
    },
    prod: {
      dashboardId: '234a776e-1543-41dc-8b27-29e48be1f737',
      sheetId: '234a776e-1543-41dc-8b27-29e48be1f737_026b30a9-aa34-4a96-b463-dfcd17f32d1a',
      visualId: '234a776e-1543-41dc-8b27-29e48be1f737_00868099-683c-49e7-80f1-8aa27bdc2518',
    },
  },
  'Leaderboard Student - Units Mastered Graph': {
    dev: {
      dashboardId: '234a776e-1543-41dc-8b27-29e48be1f737',
      sheetId: '234a776e-1543-41dc-8b27-29e48be1f737_026b30a9-aa34-4a96-b463-dfcd17f32d1a',
      visualId: '234a776e-1543-41dc-8b27-29e48be1f737_9450c301-a2e2-40b2-8ad1-8f70d9b878c2',
    },
    prod: {
      dashboardId: '234a776e-1543-41dc-8b27-29e48be1f737',
      sheetId: '234a776e-1543-41dc-8b27-29e48be1f737_026b30a9-aa34-4a96-b463-dfcd17f32d1a',
      visualId: '234a776e-1543-41dc-8b27-29e48be1f737_9450c301-a2e2-40b2-8ad1-8f70d9b878c2',
    },
  },
  'Leaderboard Non-student - 2hr Sessions': {
    dev: {
      dashboardId: '41d22138-6a56-40d8-925d-e94398a4b955',
    },
    prod: {
      dashboardId: '41d22138-6a56-40d8-925d-e94398a4b955',
    },
  },
  'Leaderboard Student - 2hr Sessions': {
    dev: {
      dashboardId: '41d22138-6a56-40d8-925d-e94398a4b955',
      sheetId: '41d22138-6a56-40d8-925d-e94398a4b955_a359c7f6-d8fe-4a41-9d4a-0b33e9b53886',
      visualId: '41d22138-6a56-40d8-925d-e94398a4b955_cde93f74-dcb7-4af8-96c7-7559fce3a674',
    },
    prod: {
      dashboardId: '41d22138-6a56-40d8-925d-e94398a4b955',
      sheetId: '41d22138-6a56-40d8-925d-e94398a4b955_a359c7f6-d8fe-4a41-9d4a-0b33e9b53886',
      visualId: '41d22138-6a56-40d8-925d-e94398a4b955_cde93f74-dcb7-4af8-96c7-7559fce3a674',
    },
  },
  'Leaderboard Student - 2hr Sessions Info': {
    dev: {
      dashboardId: '41d22138-6a56-40d8-925d-e94398a4b955',
      sheetId: '41d22138-6a56-40d8-925d-e94398a4b955_a359c7f6-d8fe-4a41-9d4a-0b33e9b53886',
      visualId: '9872d199-bb3a-42ac-ac6c-880b29136526',
    },
    prod: {
      dashboardId: '41d22138-6a56-40d8-925d-e94398a4b955',
      sheetId: '41d22138-6a56-40d8-925d-e94398a4b955_a359c7f6-d8fe-4a41-9d4a-0b33e9b53886',
      visualId: '9872d199-bb3a-42ac-ac6c-880b29136526',
    },
  },
  'L3 Payouts': {
    dev: {
      dashboardId: '6d06eb01-fd55-4b5d-b556-ee2a67d715a1',
    },
    prod: {
      dashboardId: 'c398ae13-9099-49ce-9790-5e75c58583c4',
    },
  },
  'L3 Payouts 2hr': {
    dev: {
      dashboardId: '9808888f-3d83-42f2-93d4-aea3a4cc5f6e',
    },
    prod: {
      dashboardId: 'fixme',
    },
  },
  'L2 Payouts': {
    dev: {
      dashboardId: '72aed787-0334-480c-bd30-c257d42448ce',
    },
    prod: {
      dashboardId: '9fe4ec24-215d-40b1-9d53-cbd33a5b15ac',
    },
  },
  'L2 Payouts 2hr': {
    dev: {
      dashboardId: '7002989f-4c0f-402f-be5f-0abc76fa7404',
    },
    prod: {
      dashboardId: 'fixme',
    },
  },
  'L1 Payouts': {
    dev: {
      dashboardId: 'dad63984-90ad-4069-8e6c-637ba75ee0e2',
    },
    prod: {
      dashboardId: '51228535-fb3d-42f0-8548-bf424113dee6',
    },
  },
  'L1 Payouts 2hr': {
    dev: {
      dashboardId: 'd8645f2a-477f-4f20-b424-d73c1ba93f42',
    },
    prod: {
      dashboardId: 'fixme',
    },
  },
  'Dashboard: Session': {
    dev: {
      dashboardId: 'c0d99082-d026-4869-aa63-a39f1e54d98e',
    },
    prod: {
      dashboardId: '4a2d0276-1263-4405-8a5a-66063ebe939b',
    },
  },
  'Dashboard: Session (L3)': {
    dev: {
      dashboardId: '7e9a7918-ce98-4484-80b8-52f5ac09208f',
    },
    prod: {
      dashboardId: '6704386f-a07b-485c-b9a9-98c7fd5a44f0',
    },
  },
  'My Learning Gaps': {
    dev: {
      dashboardId: 'd66225fe-341e-4e1d-bf1b-6d3467ab6981',
    },
    prod: {
      dashboardId: '1c7262da-bddc-4169-a2bb-3083c6cf2b8e',
    },
  },
  'Map Analysis': {
    dev: {
      dashboardId: '2666bfb4-d660-4dda-859d-b5a6769379ee',
    },
    prod: {
      dashboardId: 'df159979-82b6-4eae-ac9c-9b3c4fddb13f',
    },
  },
  Earnings: {
    dev: {
      dashboardId: '5972969d-44ad-401e-986b-1258a920b659',
    },
    prod: {
      dashboardId: '119175af-083e-4702-9839-ccc4aba4e157',
    },
  },
  'IXL Language': {
    dev: {
      dashboardId: '661cbed6-4cb4-4a86-9c6d-0965c3b65d60',
    },
    prod: {
      dashboardId: '661cbed6-4cb4-4a86-9c6d-0965c3b65d60',
    },
  },
  'IXL Math': {
    dev: {
      dashboardId: 'e54a885c-f74a-4b52-bf17-df739db6e41a',
    },
    prod: {
      dashboardId: 'e54a885c-f74a-4b52-bf17-df739db6e41a',
    },
  },
  'IXL Spread': {
    dev: {
      dashboardId: 'e6ac756e-597a-4796-ae2e-8170e4f1ab85',
    },
    prod: {
      dashboardId: 'e6ac756e-597a-4796-ae2e-8170e4f1ab85',
    },
  },
  'Student Mastery - Non-admin': {
    dev: {
      dashboardId: '011ccc85-228f-4df6-b203-31508e8ca1c9',
    },
    prod: {
      dashboardId: '011ccc85-228f-4df6-b203-31508e8ca1c9',
    },
  },
  'Student Mastery - Admin': {
    dev: {
      dashboardId: '954fe7eb-4890-459d-ac8c-504250747b26',
    },
    prod: {
      dashboardId: '954fe7eb-4890-459d-ac8c-504250747b26',
    },
  },
  LearningReport: {
    dev: {
      dashboardId: 'c8f3d70c-e066-4dc3-ac5c-a29bc832cff3',
    },
    prod: {
      dashboardId: 'c8f3d70c-e066-4dc3-ac5c-a29bc832cff3',
    },
  },
  'Beast of the Week': {
    dev: {
      dashboardId: 'b178641a-5a0d-4f5a-a6ee-606fdcba958b',
    },
    prod: {
      dashboardId: 'b178641a-5a0d-4f5a-a6ee-606fdcba958b',
    },
  },
  'Pre-break Learning Blitz': {
    dev: {
      dashboardId: '3c2a8f7f-d57d-4f58-acfc-93056e4bb70a',
    },
    prod: {
      dashboardId: '3c2a8f7f-d57d-4f58-acfc-93056e4bb70a',
    },
  },
  'Learn to Give': {
    dev: {
      dashboardId: 'b1923ff9-cc6a-49a3-b36a-025bfb2ec1d7',
    },
    prod: {
      dashboardId: '0ff760f0-5c58-49e5-8714-980b1a43f498',
    },
  },
  // AI-GEN START - JB AI Assistant - GPT4
  'Math Facts Challenge': {
    dev: {
      dashboardId: 'aca90e1c-9708-49ab-9f5e-b930a337b91d',
    },
    prod: {
      dashboardId: 'aca90e1c-9708-49ab-9f5e-b930a337b91d',
    },
  },
  // AI-GEN END
};

export function getQuickSightDashboard(name: string): DashboardConfig {
  const env = process.env.NEXT_PUBLIC_ENV === 'prod' ? 'prod' : 'dev';
  if (!dashboards[name]) throw new Error(`Dashboard ${name} not found.`);
  return dashboards[name][env];
}
